// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"701fbfec","61":"9ad7d6d3","127":"701fbfec","271":"a8997488","322":"9ad7d6d3","327":"9ad7d6d3","545":"676b4995","587":"9fda6aed","689":"88863856","951":"e4c064a4"}[chunkId] + ".chunk.css";
};